import ADMSPanel from '../panels/adms/ADMSPanel'
import EMDPanel from '../panels/EMDPanel/EMDHistory';
import EmptyPanel from '../panels/empty/EmptyPanel';
import i18n from '../i18n';
import DevelopmentPanel from '../panels/DevelopmnetPanel';
import AdminPanel from '../panels/admin/AdminPanel';

// /** Тест Загрузить описание  adms_ap_v201*/
// import adms_ap_v201_rdf_schema from '../semantic/adms-ap_v2.01_rdf_schema.ttl.js';
// //parser.parse(adms_ap_v201_rdf_schema, console.log);
// const N3 = require('n3');
// const { DataFactory } = N3;
// const { namedNode } = DataFactory;
// const parser = new N3.Parser();
// const storeRdf = new N3.Store();
// storeRdf.addQuads(parser.parse(adms_ap_v201_rdf_schema));
// console.log("AppCatalog.js", storeRdf.size);
// console.log("AppCatalog.js", storeRdf.getQuads(null, namedNode('http://www.w3.org/2000/01/rdf-schema#range'), namedNode('http://www.w3.org/ns/dcat#Dataset')));

export const getPanel =(store) =>{
	//Для тестирования. Настроить DevelopmentPanel и расскоментировать строку ниже
	//return DevelopmentPanel;
	
	const node = document.getElementById('settings')
	if (!node){
		alert(i18n.t('utils.panel.e_no_settings'))
    //throw new Error("Параметры панели отображения данных отсутствуют!");
    return EmptyPanel;
	}
	//console.log(node);
	const panel = node.getAttribute("panel");
	if (panel==null){
		alert(i18n.t('utils.panel.e_no_settings'))
		//throw new Error("Параметры настройки панели отображения данных отсутствуют!", panel);
    return EmptyPanel;
  }
  if (panel == 'emd') return EMDPanel;
  if (panel == 'adms') return ADMSPanel;
	if (panel == 'admin') return AdminPanel;
  alert(i18n.t('utils.panel.e_error_values'))
  return EmptyPanel;

}
